import { render } from "./Wizard.vue?vue&type=template&id=7e6ceb72"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
script.render = render

export default script